let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3O8Fd")).then(() => parcelRequire('gfs78'));